import * as React from 'react';
import { Button, Image, UIHeading4, UIText2 } from '@cian/ui-kit';

import { RENT_TEXTS, SALE_TEXTS } from './constants';
import PriceSvg from './assets/price.svg';
import HousePng from './assets/house.png';
import PriceDesktop from './assets/price_desktop.svg';

import * as styles from './styles.css';

interface IRateApartmentParams {
  isSale: boolean;
  scrollToFilters(): void;
  isDesktop: boolean;
}

export function RateApartment({ isSale, scrollToFilters, isDesktop }: IRateApartmentParams) {
  return (
    <div data-testid="RateApartment" className={styles['rate']}>
      <div className={styles['rate_box']}>
        <div className={styles['rate_box-title']}>
          <UIHeading4 as="h4">Оцените свою квартиру</UIHeading4>
        </div>
        <div className={styles['rate_info']}>
          <UIText2 as="p">{isSale ? SALE_TEXTS.info : RENT_TEXTS.info}</UIText2>
        </div>
        <Button data-testid="RateApartmentButton" onClick={scrollToFilters}>
          {isSale ? SALE_TEXTS.btnText : RENT_TEXTS.btnText}
        </Button>
        <div className={styles['rate_price']}>
          <Image src={isDesktop ? PriceDesktop : PriceSvg} />
        </div>
        <div className={styles['rate_house']}>
          <Image src={HousePng} />
        </div>
      </div>
    </div>
  );
}
